import { render, staticRenderFns } from "./BuyThirdGoods2.vue?vue&type=template&id=e6f1ca9e&scoped=true&"
import script from "./BuyThirdGoods2.vue?vue&type=script&lang=js&"
export * from "./BuyThirdGoods2.vue?vue&type=script&lang=js&"
import style0 from "./BuyThirdGoods2.vue?vue&type=style&index=0&id=e6f1ca9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f1ca9e",
  null
  
)

export default component.exports